export const getUniqueSelector = (key) => {
    return `comment-unique-selector-${key}`
};
